export class WebhookV1StandardPayloadBackupJobSucceededArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupJobSucceeded",
            "baseName": "backupJobSucceeded",
            "type": "WebhookV1BackupJobSucceededArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobSucceededArguments.attributeTypeMap;
    }
    constructor() {
    }
}
